import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { PillButton } from "@/components/PillButton";
import { IMG } from "@/lib/images";

export default function NotFoundPage() {
  return (
    <section className="relative overflow-hidden ink" data-testid="not-found-page">
      <Seo title="Page not found" />
      <img src={IMG.hallway} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0e1013] via-[#0e1013]/85 to-[#0e1013]/40" aria-hidden="true" />
      <div className="container-x relative flex min-h-[70vh] flex-col items-start justify-center py-24">
        <span className="eyebrow eyebrow-light">Error 404</span>
        <h1 className="section-title-lg mt-4 text-white">Page not found.</h1>
        <p className="lead mt-5 max-w-lg text-white/70">The page you requested may have moved or no longer exists. Let&apos;s get you back on track.</p>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <PillButton to="/" variant="primary" testId="not-found-home-button">Back to home</PillButton>
          <PillButton to="/contact" variant="outline-light" testId="not-found-contact-button">Contact us</PillButton>
        </div>
        <Link to="/services" className="mt-8 inline-flex items-center gap-1 text-sm text-white/60 hover:text-white">Browse our services <ArrowUpRight className="h-3.5 w-3.5" /></Link>
      </div>
    </section>
  );
}
